export const GET_TRENDING_PRODUCTS = 'GET_TRENDING_PRODUCTS';
export const SET_TRENDING_PRODUCTS_LOADING = 'SET_TRENDING_PRODUCTS_LOADING';
export const GET_TRENDING_PRODUCTS_SUCCESS = 'GET_TRENDING_PRODUCTS_SUCCESS';
export const GET_TRENDING_PRODUCTS_ERROR = 'GET_TRENDING_PRODUCTS_ERROR';
